export const getToken = () => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No authentication token found');
  return token;
};

export const setToken = (token) => {
  if (!token) throw new Error('Cannot store empty token');
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};